<template>
  <v-main>
    <!-- Hero Section -->
    <section class="main-container">
      <v-img
        eager
        :src="require('@/assets/img/TitleBG.png')" alt="bg_image"
        aspect-ratio=16/9
        height="100%"
        width="100%"
        class="bg-img"
      >
        <v-row
          class="mx-auto logo-img"
          align="center"
          justify-sm="center"
          justify-md="start"
          justify-lg="start"
          justify-xl="start"
        >
          <v-col sm="11" md="5" lg="5" xl="5" class="px-8">
            <v-img
              eager
              :src="require('@/assets/img/Title.png')"
              class="mx-auto"
              max-width="650px"
              contain
            />
            <p class="mt-2 text-center primary--text font-weight-bold" style="margin: auto; max-width: 400px">
              an open-world exploration game for people with perceived anxiety disorder.
            </p>
            <div style="margin: auto; max-width: 350px;" class="mt-6">
              <v-btn depressed color="primary" dark block class="text-capitalize pa-5" rounded @click="openDownloadURL">
                Download HERE
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-img>
    </section>

    <!-- Video Section -->
    <section class="main-container" v-if="videoLink">
      <v-card flat width="100%" height="100%" color="primary" class="justify-center pa-10 d-flex align-center">
        <video width="100%" height="100%" controls class="rounded-lg">
          <source :src="videoLink">
        </video>
      </v-card>
    </section>


    <!-- Describe Section -->
    <section class="py-16">
      <v-row align="center" justify="center" style="height: 100%">
        <v-col cols="9">
          <v-card outlined rounded="xl" width="100%" height="auto" elevation="3">
            <v-img
              eager
              :src="require('@/assets/img/bg.png')"
              aspect-ratio=16/9
              height="100%"
              width="100%"
            >
              <v-row align="center" justify-sm="center" justify-md="start" justify-lg="start" justify-xl="start" class="pa-10" style="height: 100%">
                <v-col sm="11" md="5" lg="5" xl="5" class="text-center">
                  <p class="text-h3 font-weight-medium">Enjoy your stay at Lulu Island!</p>
                  <p class="mt-12 text-subtitle-1">
                    Come and relax on this tropical island where you can
                    <br />
                    <span class="primary--text font-weight-bold text-h6">
                      explore, meet new friends, play mini-games or just take in the scenery!
                    </span>
                  </p>
                </v-col>
              </v-row>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </section>

    <!-- illustration Section -->
    <v-container fluid class="py-16 grey lighten-4" v-if="illustrations && illustrations.length">
      <v-row align="center" justify="center" wrap class="px-2">
        <v-col cols="12">
          <p class="text-center text-h4 font-weight-bold primary--text">
            Don't miss out on the adventure that awaits!
          </p>
        </v-col>
        <v-col
          sm="12"
          md="3"
          lg="3"
          xl="3"
          v-for="image of illustrations"
          :key="image.url"
          class="mx-4"

        >
          <img
            :ref="`illustration-${image}`"
            @mouseover="playAnimation(`illustration-${image}`)"
            @mouseleave="pauseAnimation(`illustration-${image}`)"
            :src="image"
            :lazy-src="require('@/assets/img/logo.png')"
            alt="main_character_illustration"
            width="100%"
            class="mx-auto rounded-lg elevation-6"
          />
        </v-col>
      </v-row>
    </v-container>

    <!-- Showcase Image Sections -->
    <v-container fluid class="py-16" v-if="showcase && showcase.length">
      <v-row align="center" justify="center" wrap>
        <v-col cols="12">
          <p class="text-center text-h4 font-weight-bold primary--text">
            Showcase
          </p>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="4" xl="4" v-for="image of showcase" :key="image.url" class="pa-xs-0 pa-sm-0 pa-md-0 pa-lg-10">
          <img
            :ref="`showCase-${image}`"
            @mouseover="playAnimation(`showCase-${image}`)"
            @mouseleave="pauseAnimation(`showCase-${image}`)"
            :src="image"
            :lazy-src="require('@/assets/img/logo.png')"
            alt="main_character_illustration"
            width="100%"
            class="mx-auto rounded-lg elevation-6"
          />
        </v-col>
      </v-row>
    </v-container>

    <!-- Encouragement -->
    <v-container fluid class="py-16">
      <v-row align="center" justify="center">
        <v-col sm="11" md="9" lg="9" xl="9">
          <v-card color="primary" rounded="lg" class="elevation-12 pa-9">
            <p class="text-center align-self-center text-h4 white--text font-weight-semibold font-italic">"It doesn't hurt to give yourself a break once in a while!"</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </v-main>
</template>

<script>
  import Footer from '@/components/Footer.vue';
  import { animate } from "motion"

  export default {
    name: 'Home',
    components: { Footer },
    data: () => ({
      animation: null
    }),
    async created() {
      if (!this.showcase || !this.showcase.length || !this.illustrations || !this.illustrations.length) {
        await this.$store.dispatch('cms/POPULATE_HOME');
      }
    },
    computed: {
      downloadURL() {
        return this.$store.getters['cms/DOWNLOAD_URL'];
      },
      videoLink() {
        return this.$store.getters['cms/VIDEO_LINK']
      },
      illustrations() {
        return this.$store.getters['cms/ILLUSTRATIONS'];
      },
      showcase() {
        return this.$store.getters['cms/SHOWCASE'];
      }
    },
    methods: {
      openDownloadURL() {
        window.open(this.downloadURL);
      },
      playAnimation(refName) {
        const showCase = this.$refs[refName]
        this.animation = animate(
          showCase,
          {
            y: -20,
            scale: 1.025,
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
          },
          {
            duration: 0.5,
            easing: "ease-in-out",
            repeat: 0,
            direction: "normal"
          }
        )
        this.animation.play()
      },
      async pauseAnimation(refName) {
        const showCase = this.$refs[refName]
        this.animation = animate(
          showCase,
          { y: 0, scale: 1, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" },
          {
            duration: 0.5,
            easing: "ease-in-out",
            repeat: 0,
            direction: "normal"
          }
        )
        await this.animation.play()
        // await this.animation.cancel()
      }
    }
  }
</script>

<style>
  .bg-img {
    z-index: 0;
  }

  .logo-img {
    z-index: 1000;
    height: 100%;
    width: 100%;
  }

  .main-container {
    position: relative;
    height: 800px;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }

  .check-sides {
    margin: auto;
    padding: auto;
  }
</style>
